// extracted by mini-css-extract-plugin
export default {"vbUiBtn":"km0_Y__vbUiBtn","vbSecondaryBtn":"xUliZ__vbSecondaryBtn km0_Y__vbUiBtn"};